import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getSentNewOffers } from "../../reduxStore/entities/offers";
import Layout from "../../core/Layout";

// MUI v5 imports
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Paper, Grid, Box } from "@mui/material";
import { styled } from '@mui/system';

// Define custom styles using styled
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    '&.MuiTableCell-head': {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    '&.MuiTableCell-body': {
        // Add any custom styles for body cells here
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
}));

const columns = [
    { id: 'part_offer_id', label: 'ID', minWidth: 100 },
    { id: 'title', label: 'Title', minWidth: 100 },
    { id: 'description', label: 'Description', minWidth: 170 },
    { id: 'type', label: 'Type', minWidth: 170 },
    { id: 'price', label: 'Price', minWidth: 170 },
];

function createData(part_offer_id, title, description, type, price) {
    return { part_offer_id, title, description, type, price };
}

export default function SentOffers() {
    const navigate = useNavigate();
    const offers = useSelector((state) => state.offers.sentNewOffers);
    const dataLoaded = useSelector((state) => state.offers.sentDataLoaded);
    const dispatch = useDispatch();
    const [rows, setRows] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleTableLoad = (offers) => {
        return offers.map((offer) => createData(offer.part_offer_id, offer.title, offer.description, offer.type, offer.price));
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleClick = (id) => {
        navigate(`/admin/offers/${id}`);
    };

    useEffect(() => {
        const fetchOffers = async () => {
            await dispatch(getSentNewOffers());
        };
        fetchOffers();
    }, [dispatch]);

    useEffect(() => {
        if (dataLoaded) {
            setRows(handleTableLoad(offers));
        }
    }, [offers, dataLoaded]);

    return (
        <Layout>
            <Box>
                {dataLoaded ? (
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer>
                                    <Table stickyHeader aria-label="sent offers table">
                                        <TableHead>
                                            <TableRow>
                                                {columns.map((column) => (
                                                    <StyledTableCell key={column.id} style={{ minWidth: column.minWidth }}>
                                                        {column.label}
                                                    </StyledTableCell>
                                                ))}
                                                <StyledTableCell></StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                                                <StyledTableRow hover key={row.part_offer_id}>
                                                    {columns.map((column) => (
                                                        <StyledTableCell key={column.id} align="left">
                                                            {row[column.id]}
                                                        </StyledTableCell>
                                                    ))}
                                                    <StyledTableCell>
                                                        <Button variant="contained" onClick={() => handleClick(row.part_offer_id)}>
                                                            Details
                                                        </Button>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 100]}
                                    component="div"
                                    count={rows.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                ) : (
                    <div>Loading...</div>
                )}
            </Box>
        </Layout>
    );
}
